export default __webpack_public_path__ + "assets/gilson-cidrim-component.fa29b836.svg";